import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { BodyContainer } from '../../../elements';
import { CommonUtility, Tabs } from '../../../utility';
import { RouteTabs } from '../../../components';
import {
  InventorySuggestedTransferListScreen,
  InventoryTransferListScreen,
  InventoryTransferWavesListScreen,
} from '../../../page-components';
import { useGlobalContext, useSidebarMetadata } from '../../../contexts';
import { TransferTabExtraContext } from '../../../contexts/transfer-tab-extra';
import { useSecondaryHeader } from '../../../hooks/useSecondaryHeader';

function TransferSecondaryHeader({ menus, currentTab, tabClicked }) {
  const { tabExtra } = useContext(TransferTabExtraContext);

  return (
    <RouteTabs
      items={menus}
      activeKey={currentTab}
      onChange={tabClicked}
      tabBarExtraContent={tabExtra}
      className="no-header"
    />
  );
}

export function TransferDetailScreen() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { warehouseId } = useGlobalContext();

  const { inventory } = useSidebarMetadata();

  const currentTab = useMemo(() => {
    if (pathname) {
      return CommonUtility.getSegmentByPosition(pathname, 4);
    }
    return null;
  }, [pathname]);

  const tabClicked = tabName => {
    navigate(`/app/inventory/transfer/${tabName}`);
  };

  const menus = useMemo(
    () => [
      {
        text: 'Scheduled',
        value: Tabs.TransferTabs.scheduled,
        count: inventory?.inventoryTransfer.scheduled,
      },
      {
        text: 'Suggested',
        value: Tabs.TransferTabs.suggested,
        count: inventory?.inventoryTransfer.suggested,
      },
      {
        text: 'Transfer Batches',
        value: Tabs.TransferTabs.transferWaves,
      },
    ],
    [inventory],
  );

  useSecondaryHeader(
    () => (
      <TransferSecondaryHeader
        menus={menus}
        currentTab={currentTab}
        tabClicked={tabClicked}
      />
    ),
    [currentTab, tabClicked, menus],
  );

  return (
    <BodyContainer className="tab-layout no-header">
      <Routes>
        <Route index element={<Navigate to={Tabs.TransferTabs.scheduled} />} />
        <Route
          path={Tabs.TransferTabs.scheduled}
          element={<InventoryTransferListScreen warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.TransferTabs.suggested}
          element={<InventorySuggestedTransferListScreen warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.TransferTabs.transferWaves}
          element={<InventoryTransferWavesListScreen warehouseId={warehouseId} />}
        />
      </Routes>
    </BodyContainer>
  );
}
